<mat-card *ngIf="medicine" class="medicine-view">
    <div class="row" *ngIf="medicine">
        <div class="col-md-6">
            <mat-card-title>{{medicine.name}}</mat-card-title>
        </div>
        <div class="col-md-6 text-end">
            <button *authGroup="['SuperAdmin']" mat-flat-button color="warn" (click)="delete()" class="me-2">
                Delete 
            </button>
            <button *authGroup="['SuperAdmin', 'Prescription']"  color="primary" mat-flat-button (click)="editMode = !editMode">
                {{editMode ? 'Details' : 'Edit'}}
            </button>
        </div>
    </div>
    <p class="mt-2">
        <button mat-stroked-button (click)="backToList()" class="me-2">
            <mat-icon>arrow_back</mat-icon> Back to list
        </button>
    </p>
    <div *ngIf="editMode">
        <form class="mt-3" [formGroup]="medicineForm">

            <div class="row">
                <div class="col-md-6">
                    <p>
                        <mat-form-field appearance="outline">
                            <mat-label>Name</mat-label>
                            <input formControlName="name" type="text" matInput placeholder="Name">
                            <mat-error *ngIf="medicineForm.get('name')?.invalid">
                                Name is invalid
                            </mat-error>
                        </mat-form-field>
                    </p>

                    <p>
                        <mat-form-field appearance="outline">
                            <mat-label>Barcode prefix</mat-label>
                            <input formControlName="barcodePrefix" type="text" matInput placeholder="Barcode prefix">
                            <mat-error *ngIf="medicineForm.get('barcodePrefix')?.invalid">
                                Barcode prefix is invalid
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>

                <div class="col-md-6">
                    <p>
                        <mat-form-field appearance="outline">
                            <mat-label>Active ingredient</mat-label>
                            <input formControlName="activeIngredient" type="text" matInput
                                placeholder="Active ingredient">
                            <mat-error *ngIf="medicineForm.get('activeIngredient')?.invalid">
                                Active ingredient is invalid
                            </mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline">
                            <mat-label>Active ingredient nappy code</mat-label>
                            <input formControlName="activeIngredientNappyCode" type="text" matInput
                                placeholder="Barcode prefix">
                            <mat-error *ngIf="medicineForm.get('activeIngredientNappyCode')?.invalid">
                                Active ingredient nappy code is invalid
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>

            </div>

            <p>
                <mat-form-field appearance="outline">
                    <mat-label>Schedule status</mat-label>
                    <mat-select formControlName="scheduleStatus">
                        <mat-option *ngFor="let status of scheduleStatuses" [value]="status">
                            {{status}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="medicineForm.get('scheduleStatus')?.invalid">
                        Schedule status is invalid
                    </mat-error>
                </mat-form-field>
            </p>

            <p>
                <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <textarea formControlName="description" matInput placeholder="Description"></textarea>
                    <mat-error *ngIf="medicineForm.get('description')?.invalid">
                        Description is invalid
                    </mat-error>
                </mat-form-field>
            </p>

            
            <p>
                <mat-checkbox formControlName="canOrder" color="primary">
                    Can be Ordered
                </mat-checkbox>
            </p>

        </form>
        <div class="text-end mt-2">
            <button (click)="save()" mat-raised-button color="primary">
                <mat-icon>save</mat-icon> Save
            </button>
        </div>
    </div>
    <div *ngIf="!editMode && medicine" class="details mt-3">
        <table>
            <tr>
                <th>
                    Name
                </th>
                <td>
                    {{medicine.name ? medicine.name : '-'}}
                </td>
            </tr>
            <tr>
                <th>
                    Description
                </th>
                <td>
                    {{medicine.description ? medicine.description : '-'}}
                </td>
            </tr>
            <tr>
                <th>
                    Barcode prefix
                </th>
                <td>
                    {{medicine.barcode_prefix ? medicine.barcode_prefix : '-'}}
                </td>
            </tr>
            <tr>
                <th>
                    Active ingredient
                </th>
                <td>
                    {{medicine.active_ingredient ? medicine.active_ingredient : '-'}}
                </td>
            </tr>
            <tr>
                <th>
                    Active ingredient nappy code
                </th>
                <td>
                    {{medicine.active_ingredient_nappy_code ? medicine.active_ingredient_nappy_code : '-'}}
                </td>
            </tr>
            <tr>
                <th>
                    Schedule status
                </th>
                <td>
                    {{medicine.schedule_status}}
                </td>
            </tr>
            <tr>
                <th>Order System</th>
                <td *ngIf="medicine.can_be_ordered !== null">
                    <mat-checkbox [checked]="medicine.can_be_ordered" color="primary"></mat-checkbox>
                </td>
            </tr>
            
            
            
            <tr>
                <th>
                    Created
                </th>
                <td>
                    {{formatTime(medicine.created_at)}}
                </td>
            </tr>
            <tr>
                <th>
                    Updated
                </th>
                <td>
                    {{formatTime(medicine.updated_at)}}
                </td>
            </tr>

        </table>
    </div>
    <div class="mb-2 mt-3">

        <div class="py-2">
            <mat-divider></mat-divider>
        </div>

        
        <div class="row my-2">
            <div class="col-md-6">
                <h2>Dosage and package types</h2>
            </div>
            <div class="col-md-6 text-end">
                <button *authGroup="['SuperAdmin']" class="me-2" mat-stroked-button (click)="createMedicineDosageType()">
                    <mat-icon>add</mat-icon> Create new
                </button>
                <button mat-stroked-button (click)="refreshMedicineDosageTypes(true)">
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>
        
        <core-medicine-dosage-types-list [medicineId]="medicine.id"
            (onMedicineDosageTypeUpdated)="refreshMedicineDosageTypes($event)"
            [medicineDosageTypes]="medicineDosageTypes" [dosageTypes]="dosageTypes" [packageTypes]="packageTypes"
            [dosageUnits]="dosageUnits"></core-medicine-dosage-types-list>

    </div>
</mat-card>